<p align = center>
<app-button
   [btnOption]="btnOption"
   (clickEvent)="_actionGuestLogin()"
></app-button>
</p>

<form role="form" name="guestLoginForm" novalidate="" class="form-validate">
</form>
